import { combineReducers } from "redux";
import authReducer from "./reducers/authReducer";
import errorReducer from "./reducers/errorReducer";
import mqttReducer from "./reducers/mqttReducer";

export default combineReducers({
    auth: authReducer,
    errors: errorReducer,
    mqtt: mqttReducer
});
